import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { SadJaneIcon } from '../../assets/SadJaneIcon.js';
import { GenericErrorMessageText, GenericErrorMessageWrapper } from './GenericErrorMessage.styled.js';
export const isEnvDevelopment = [
    'development',
    'sandbox1',
    'e2etest',
    'sandbox2',
    'sandbox3',
    'sandbox4',
    'sandbox5',
    'sandbox6',
    'sandbox7',
    'sandbox8',
    'sandbox9',
    'tobox',
    'tobox2',
    'tobox3',
].includes(process.env['REACT_APP_BKJ_ENVIRONMENT'] || 'default');
export function GenericErrorMessage({ errorMessage, size = 'Small', width = '100%', height = '100%', direction = 'column', suppressMessage = false, isStyled = false, showLogo = true, ...rest }) {
    return (_jsx(GenericErrorMessageWrapper, { isStyled: isStyled, size: size, width: width, height: height, direction: direction, ...rest, children: !suppressMessage && (_jsxs(Fragment, { children: [showLogo && _jsx(SadJaneIcon, { size: size, direction: direction }), (process.env['NODE_ENV'] === 'development' || isEnvDevelopment) && errorMessage && (_jsx(GenericErrorMessageText, { size: size, direction: direction, children: errorMessage })), process.env['NODE_ENV'] === 'production' && errorMessage && (_jsxs(Fragment, { children: [_jsx(GenericErrorMessageText, { size: size, direction: direction, children: "Oops! Something went wrong" }), _jsx(GenericErrorMessageText, { size: size, direction: direction, children: "Try refreshing the browser" })] }))] })) }));
}
//# sourceMappingURL=GenericErrorMessage.js.map